'use client';

import { useParams, useRouter } from 'next/navigation';
import CookieBanner from '@ab-inbev-eu/ui-library/components/composite/cookie-banner/CookieBannerObserver';

export default function CookieBannerObserver() {
  const router = useRouter();
  const { qrId }: { qrId: string } = useParams();

  function handlePPClick(e: MouseEvent) {
    e.preventDefault();
    router.push(`/qr/${qrId}/privacy-policy?session=true`);
  }
  // TODO: locize text content after the implementation of the locize integration
  return <CookieBanner textContent={'Show more'} handlePPClick={handlePPClick} />;
}
